const userRoles = [
  { name: "Student", id: "550bb434-47b9-11e6-99d5-69f89f362f48", idInt: 1 },
  { name: "Coach", id: "550bb484-47b9-11e6-99d5-69f89f362f48", idInt: 2 },
  { name: "Coordinator", id: "550bb4a2-47b9-11e6-99d5-69f89f362f48", idInt: 3 },
  { name: "Admin", id: "e5ad5b4a-4878-11e6-8f8d-686ce32e3eaa", idInt: 4 },
  {
    name: "Usuario de Comunicación",
    id: "2F7AEE9B-1C29-4844-899D-8CE265F34A41",
    idInt: 29
  },
  {
    name: "Administrador de Comunicación",
    id: "DB6FF91E-E160-4FF6-9F8A-FC6CF8DF4CAC",
    idInt: 28
  },
  { name: "CAT Admin", id: "cc8a91ba-5356-400e-a5d9-3d146180b5de", idInt: 30 },
  { name: "CAT", id: "9b9c5a1c-e971-11e6-9d6d-705a0f1d8d42", idInt: 18 },
  { name: "Ambassador", id: "20ed2b25-89c8-434a-9b9e-11f24e852fbe", idInt: 27 },
  { name: "Relative", id: "3436a108-96ea-11e6-ac7e-06540b81ad45", idInt: 10 },
];

export default {
  namespaced: true,

  state: {
    userRoles: userRoles,
  },
};

export async function getUserTypeIntByUuid (uuid) {
   const getIdIntA = userRoles.find(({id}) => id == uuid);
   return getIdIntA.idInt;
}
